
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M22 9.00005H17.21L12.82 2.43005C12.42 1.84005 11.55 1.84005 11.16 2.43005L6.77 9.00005H2C1.45 9.00005 1 9.45005 1 10C1 10.09 1.01 10.18 1.04 10.27L3.58 19.5401C3.81 20.3801 4.58 21 5.5 21H18.5C19.42 21 20.19 20.3801 20.43 19.5401L22.97 10.27L23 10C23 9.45005 22.55 9.00005 22 9.00005ZM11.99 4.79005L14.8 9.00005H9.18L11.99 4.79005ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-shopping-basket`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconShoppingBasket

    ```js
    <b-new-b-icon-shopping-basket />
    ```
</docs>


